import multiguard from 'vue-router-multiguard'

import store from '@/store'

const defineIsAuthorized = () => {
  const isAuthorized = store.getters['auth/isAuthorized']

  return new Promise(resolve => {
    if (isAuthorized !== null) resolve(isAuthorized)

    const timer = setTimeout(() => resolve(false), 30000)

    store.watch(
      () => store.getters['auth/isAuthorized'],
      value => {
        clearTimeout(timer)
        resolve(value)
      }
    )
  })
}

export const onlyNotAuthorized = async (to, from, next) => {
  const isAuthorized = await defineIsAuthorized()

  if (!isAuthorized) return next()

  next({ name: 'hub' })
}

export const onlyAuthorized = async (to, from, next) => {
  const isAuthorized = await defineIsAuthorized()

  if (isAuthorized) return next()

  store.dispatch('auth/LOGOUT', null, { root: true })
  next({ name: 'signin' })
}

export const onlyPremium = async (to, from, next) => {
  await defineIsAuthorized()

  const isPremium = store.getters['user/isPremium']

  if (isPremium) return next()

  next({ name: 'hub.paywall' })
}

export const onlyOnboarded = async (to, from, next) => {
  await defineIsAuthorized()

  const isOnboarded = store.getters['user/isOnboarded']

  if (isOnboarded) return next()

  next({ name: 'onboarding' })
}

export const onlyNotOnboarded = async (to, from, next) => {
  await defineIsAuthorized()

  const isOnboarded = store.getters['user/isOnboarded']

  if (!isOnboarded) return next()

  next({ name: 'hub' })
}

export const onlyNotPremium = async (to, from, next) => {
  await defineIsAuthorized()

  const isPremium = store.getters['user/isPremium']

  if (!isPremium) return next()

  next({ name: 'home' })
}

export const checkTopicAccess = async (to, from, next) => {
  // const isPremiumTopic = store.getters['topics/defineIsPremiumTopicBySlug'](
  //   to.params.topicSlug
  // )
  const isLockedForDemo = store.getters['topics/defineIsLockedForDemo'](
    to.params.topicSlug
  )

  if (isLockedForDemo) {
    const isAuthorized = await defineIsAuthorized()
    const isPremium = store.getters['user/isPremium']

    if (!isAuthorized || !isPremium) {
      next({ name: 'hub.sections' })
      store.commit('ui/SET_UI_TARIFFS_MODAL_IS_VISIBLE', true, { root: true })

      return
    }
  }

  next()
}

export const onlyFromPaymentStatusPage = async (to, from, next) => {
  const isFromPaymentStatus = from.name === 'public.payment-status'

  if (isFromPaymentStatus) {
    return next()
  }

  next({ name: 'home' })
}

export const onlyFromSigninPages = async (to, from, next) => {
  const isFromSigninPages = from.name?.includes('signin')

  if (isFromSigninPages) {
    return next()
  }

  next({ name: 'home' })
}

export const onlyAdmin = async (to, from, next) => {
  await defineIsAuthorized()

  const isAdmin = store.getters['user/isAdmin']

  if (isAdmin) return next()

  next({ name: 'home' })
}

export const multiple = multiguard
